import { Badge } from "@/components/ui/badge";
import { Clock, Users, CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface SignatureStatusBadgeProps {
  status: 'not_requested' | 'pending' | 'in_progress' | 'completed';
  signedCount?: number;
  totalSigners?: number;
}

export function SignatureStatusBadge({ 
  status, 
  signedCount = 0, 
  totalSigners = 0 
}: SignatureStatusBadgeProps) {
  if (status === 'not_requested') return null;
  
  const variants = {
    pending: { color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300', icon: Clock },
    in_progress: { color: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300', icon: Users },
    completed: { color: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300', icon: CheckCircle },
  };
  
  const { color, icon: Icon } = variants[status] || variants.pending;
  
  return (
    <Badge className={cn("text-xs gap-1", color)}>
      <Icon className="h-3 w-3" />
      {status === 'completed' ? (
        'All Signed'
      ) : (
        `${signedCount} of ${totalSigners} signed`
      )}
    </Badge>
  );
}
